<div class="dialog">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <h2 class="ui-headline">{{ '2fa.enabled.modal.title' | translate }}</h2>
    <p>{{ '2fa.enabled.modal.p' | translate }}</p>
    <div class="ui-button-group reverse">
      <button (click)="close()" class="ui-button secondary">{{ '2fa.enabled.cta2' | translate }}</button>
      <button (click)="switchOff()" class="ui-button">{{ '2fa.enabled.cta1' | translate }}</button>
    </div>
  </div>
</div>
